@if (isActive()) {
  <div
    class="tab-bar-active-marker-container"
    [class.inactive]="inactive() && !inMovement()"
    [class.disabled]="disabled()"
    [class.opaque]="opaque()"
    [@moveMarker]="moveMarker()"
  >
    <div class="tab-bar-active-marker"></div>
  </div>
}

<button
  class="tab-bar-item body-bold"
  [class.opaque]="opaque()"
  [class.disabled]="disabled()"
  [class.active]="preIsActive()"
  [class.icon]="icon()"
  (click)="onClick()"
>
  @if (fa_icon()) {
    <i [class]="'fa fa-' + fa_icon()" aria-hidden="true"></i>
  }

  @if (svg_icon()) {
    <div
      class="svg-icon mini-icon"
      [class.chrome]="isChrome"
      [ngStyle]="{
        mask: 'url(' + svg_icon() + ')',
        '-webkit-mask': 'url(' + svg_icon() + ')',
        '-webkit-mask-size': 'cover',
        'mask-size': 'cover',
      }"
    ></div>
  }

  <span>
    <ng-content></ng-content>
  </span>
</button>
